import { LOCALES } from 'i18n/locales';

export const enquiryAlertsIntl = {
    [LOCALES.ENGLISH]: {
        'enquiryAlerts.emergency.title': 'Important',
        'enquiryAlerts.emergency': 'This form is for emergency unplanned works only.',
        'enquiryAlerts.error.title': 'Important',
        'enquiryAlerts.error': 'Your submission has taken longer than expected to generate. Please check its progress on enquiries page.',
        'enquiryAlerts.button': 'Review Enquiry',
        'enquiryAlerts.success.title': 'Enquiry submitted',
        'enquiryAlerts.success': 'Enquiry ID',
        'enquiryAlerts.modal.button.save.text': 'Accept and continue'
    },
    [LOCALES.WELSH]: {
        'enquiryAlerts.emergency.title': 'Pwysig',
        'enquiryAlerts.emergency': 'Maeír ffurflen hon ar gyfer gwaith brys heb ei gynllunio yn unig.',
        'enquiryAlerts.error.title': 'Pwysig',
        'enquiryAlerts.error': 'Mae\'ch cyflwyniad wedi cymryd mwy na\'r disgwyl i\'w gynhyrchu. Gwiriwch ei gynnydd ar dudalen ymholiadau.',
        'enquiryAlerts.button': 'Ymholiad Adolygu',
        'enquiryAlerts.success.title': 'Ymholiad wedi\'i Gadw',
        'enquiryAlerts.success': 'Mae eich ymholiad wedi\'i gadw. Cliciwch ar y dudalen<Link>Ymholiadau</Link>i weld statws eich pecyn gwaith',
        'enquiryAlerts.modal.button.save.text': 'Derbyn a pharhau'
    }
};
